import { Controller } from "@hotwired/stimulus"
import { highchartsSetupV12 } from "@xlayer/composables/chartModules/highchartsSetup"
import { createApp } from "vue"
import XTableComponent from "@xlayer/components/XTableComponent.vue"
import XScoreComponent from "@xlayer/components/XScoreComponent.vue"
import XChartComponent from "@xlayer/components/XChartComponent.vue"


export default class extends Controller {
  static values = { data: String, filter: String, id: String, layout: String }

  connect() {
    if (this.vueApp) {
      this.vueApp.unmount();
    }
    highchartsSetupV12()
    const components = JSON.parse(this.dataValue)
    
    if (components && components.length > 0) {
      components.forEach(component => {
        switch (component.type) {
          case "chart":
            this.renderChartComponent(component)
            break
          case "score":
            this.renderScoreComponent(component)
            break
          case "table":
            this.renderTableComponent(component)
            break
        }
      })
    }
  }
  
  disconnect() {
    if (this.vueApp) {
      this.vueApp.unmount();
    }
  }
  
  private async waitForRenderingComplete(container: HTMLElement) {
    await Promise.all([
      // Wait a bit for component to render
      new Promise(resolve => setTimeout(resolve, 100)),
      // Wait for fonts to load
      document.fonts.ready
    ]);

    if (container) {
      // Add the selector that pupeteer is waiting for
      container.classList.add('chart-rendered');
      
      // Remove all scripts
      document.querySelectorAll('script').forEach(script => {
        script.remove();
      });
    }
  }

  renderChartComponent(component) {
    const chartId = `chart-container-${component.id}`
    const template = this.createComponentTemplate("chart-template", chartId, component.display)
    this.element.appendChild(template);
    
    const modelValue = component
    const app = createApp(XChartComponent, { modelValue });
    const chartContainer = document.getElementById(chartId)
    app.mount(chartContainer);

    this.vueApp = app;

    this.waitForRenderingComplete(chartContainer);
  }
  
  renderScoreComponent(component) {
    const chartId = `score-container-${component.id}`
    const template = this.createComponentTemplate("score-template", chartId, component.display)
    this.element.appendChild(template);

    const modelValue = component
    const app = createApp(XScoreComponent, { modelValue });
    const chartContainer = document.getElementById(chartId)
    app.mount(chartContainer);

    this.vueApp = app;

    this.waitForRenderingComplete(chartContainer);
  }

  renderTableComponent(component) {
    const chartId = `table-container-${component.id}`
    const template = this.createComponentTemplate("table-template", chartId, component.display)
    
    if (component.tableData.isBig) {
      const titleElement = template.querySelector(".title")
      if (titleElement) {
        titleElement.classList.add('big-title')
      }
    }
    
    this.element.appendChild(template);
    
    const modelValue = component.tableData
    const app = createApp(XTableComponent, { modelValue });
    const chartContainer = document.getElementById(chartId)
    app.mount(chartContainer);
    
    this.vueApp = app;
    
    this.waitForRenderingComplete(chartContainer);
  }

  createComponentTemplate(templateId, chartId, display) {
    const template = document.getElementById(templateId).content.cloneNode(true)
    if (chartId) {
      const chartContainer = template.querySelector(".chart-container")
      chartContainer.id = chartId
    }

    if (display?.header?.title) {
      const titleElement = template.querySelector(".title")
      if (titleElement) {
        titleElement.innerHTML = display.header.title
      }
    }
    return template
  }
  
  
}
